import React from 'react';
import classNames from 'classnames/bind';
import PageLink from 'components/PageLink/PageLink';
import styles from './HighlightedBox.module.scss';

export enum THEME {
  BLUE = 'blue',
  GREEN = 'green',
}

type Props = {
  children: React.ReactNode;
  theme?: THEME;
  buttonText?: string;
  buttonUrl?: string;
  onClick?: () => void;
};

const cx = classNames.bind(styles);

const HighlightedBox = ({ children, theme, buttonText, buttonUrl, onClick }: Props) => {
  const wrapperStyle = cx({
    wrapper: true,
    green: theme === THEME.GREEN,
    blue: theme === THEME.BLUE,
  });

  return (
    <div className={wrapperStyle}>
      <div className={styles.content}>
        {children}
      </div>
      {onClick && buttonText && (
        <button onClick={() => onClick()} className={styles.ctaButton}>
          {buttonText}
        </button>
      )}
      {buttonUrl && buttonText && (
        <PageLink
          text={buttonText}
          url={buttonUrl}
          className={styles.ctaButton}
        />
      )}
    </div>
  );
};

export default HighlightedBox;
